import { Clock, MapPin, Pizza } from "lucide-react";

export const StoreHeader = ({ settings }) => (
  <header className="relative" data-testid="store-header">
    <div className="relative h-56 sm:h-72 overflow-hidden">
      {settings.banner ? (
        <img src={settings.banner} alt="Banner" className="w-full h-full object-cover" data-testid="store-banner" />
      ) : (
        <div className="w-full h-full bg-gradient-to-br from-[#991B1B] to-[#120E0E]" />
      )}
      <div className="absolute inset-0 bg-gradient-to-t from-[#120E0E] via-[#120E0E]/60 to-transparent" />
    </div>
    <div className="relative -mt-20 px-5 max-w-3xl mx-auto rise">
      <div className="flex items-end gap-4">
        <div className="w-20 h-20 rounded-2xl bg-[#1C1515] border-2 border-amber-500/70 overflow-hidden flex items-center justify-center shadow-xl shrink-0">
          {settings.logo ? (
            <img src={settings.logo} alt="Logo" className="w-full h-full object-cover" data-testid="store-logo" />
          ) : (
            <Pizza className="w-10 h-10 text-amber-400" />
          )}
        </div>
        <div className="pb-1 min-w-0">
          <h1 className="text-[26px] sm:text-5xl font-extrabold tracking-tight text-amber-50 leading-[1.05] break-words" data-testid="store-name">
            {settings.business_name}
          </h1>
          <p className="text-xs uppercase tracking-[0.25em] text-amber-400/90 mt-2">Menú digital · Pedí online</p>
        </div>
      </div>
      <div className="flex flex-wrap gap-2 mt-5">
        <span className="inline-flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-full bg-amber-500/10 text-amber-400 border border-amber-500/30" data-testid="store-wait-time">
          <Clock className="w-3.5 h-3.5" /> Espera aprox. {settings.wait_time}
        </span>
        {settings.address && (
          <span className="inline-flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-full bg-white/5 text-[#A89F91] border border-[#2E2323]" data-testid="store-address">
            <MapPin className="w-3.5 h-3.5" /> {settings.address}
          </span>
        )}
      </div>
    </div>
  </header>
);
